The formatted name of a person, as it would be written out together.
